type CroppedAreaPixels = {
    x: number
    y: number
    width: number
    height: number
}

export const getCroppedImg = (
    imageSrc: string,
    croppedAreaPixels: CroppedAreaPixels
): Promise<Blob> => {
    return new Promise((resolve, reject) => {
        const image = new Image()
        image.src = imageSrc
        image.crossOrigin = "anonymous"
        image.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = croppedAreaPixels.width
            canvas.height = croppedAreaPixels.height
            const ctx = canvas.getContext('2d')

            if (!ctx) {
                reject(new Error("Could not get canvas context"))
                return
            }

            ctx.drawImage(
                image,
                croppedAreaPixels.x,
                croppedAreaPixels.y,
                croppedAreaPixels.width,
                croppedAreaPixels.height,
                0,
                0,
                croppedAreaPixels.width,
                croppedAreaPixels.height
            )

            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error("Canvas is empty"))
                    return
                }
                resolve(blob)
            }, 'image/jpeg')
        }
        image.onerror = (err) => reject(err)
    })
}